import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const LoaderOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ themeMode }) => themeMode === 'dark' ? '#181818' : '#fff'};
  color: ${({ themeMode }) => themeMode === 'dark' ? '#fff' : '#181818'};
  animation: ${fadeIn} 0.4s;
  transition: background 0.5s, color 0.5s;
  /* Prevent text selection */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

const LoadingText = styled.div`
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 2px;
  text-align: center;
  text-shadow: 0 2px 8px ${({ themeMode }) => themeMode === 'dark' ? '#0008' : '#8882'};
  animation: blink 1.5s infinite alternate;
  /* Prevent text selection */
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  @keyframes blink {
    0% { opacity: 1; }
    100% { opacity: 0.7; }
  }
`;

const LoadingPage = ({ theme = 'light' }) => (
  <LoaderOverlay themeMode={theme}>
    <LoadingText themeMode={theme}>Loading...</LoadingText>
  </LoaderOverlay>
);

export default LoadingPage; 